import type { GetProp } from "antd";
import type { ColorPickerProps } from "antd/lib";

type Color = GetProp<ColorPickerProps, "value">;

export const getColorPickerValue = (color?: Color): string | undefined => {
  if (color instanceof Object) {
    return (color as { toHex?: () => string }).toHex?.() ?? "000000";
  }
  return color;
};
